import { useContext } from "react";
import Card from "../components/Card";
import { SocketContext } from "../contexts/SocketContext";
import SwitchCardsIcon from "./Icons/SwitchCardsIcon";

function Table({usernames, isReveal}) {
  const { cardValue, countdown, counting, averageScore } = useContext(SocketContext);

  return (
    <div className='table'>   
      {!isReveal && <div className='table-info'>{cardValue ? "Wait for the card reveal" : "Choose a card"}</div>}
      {counting && <div className='table-info'>{countdown}</div>}
      {isReveal && !counting && <div className="average-score">Average score: <b>{averageScore.toFixed(2)}</b></div>}
      <div>
        {usernames.map(({ username, cardValue, cardStyle, customCardStyle }) => <Card key={`${username}-table-card`} cardStyles={cardStyle} customCardStyle={customCardStyle} name={username} isReveal={isReveal && !counting} cardValue={cardValue} />)}
      </div>
      {/*<div className="settings-icon">
        <SwitchCardsIcon />
      </div>*/}
    </div>
  );
}

export default Table;
